import React from 'react'
import './index.css'
import Footer from '../components/Footer'
import TopNav from '../components/TopNav'
import GmaBanner from '../components/GmaBanner'

const Photos: React.FC = () => {
    return (
        <>
            <TopNav />
            <div className="container-fluid w-100 h-auto mt-5 p-0">
                <img src="./img/communityheader.jpg" className="img-fluid w-100 p-0 m-0 top-image" alt="Community members at House event" />
            </div>
            <section className="photos-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            <header className="text-center section-header">
                                <h1 className="text-uppercase py-1 subheading">Photos from our events</h1>
                            </header>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <h2 className="text-center mt-5">Coming Soon!</h2>
                </div>
            </section>
            <div className="row">
                <div className="col">
                    <GmaBanner />
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Photos
